<template>
  <v-dialog v-model="dialog" scrollable max-width="70%" persistent>
    <v-card>
      <v-card-title>
        <v-row class="ma-0 pa-0">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
          <v-col class="pt-0 pb-0 text-center" cols="12">
            <h1>Lista de Anexos {{tipoConsulta=="guias"? "das Guias": "dos Itens"}}</h1>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="px-6 pt-12" cols="12">
            <v-row v-for="(item, ind) in listaArquivos" :key="item.id">
              <v-col class="px-2 py-1 text-left" cols="3">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="pt-0 pb-2 pr-4" small v-if="item.tipo_anexo == 1" color="primary" v-bind="attrs" v-on="on">fa-pills</v-icon>
                      <v-icon class="pt-0 pb-2 pr-4" small v-if="item.tipo_anexo == 2" color="primary" v-bind="attrs" v-on="on">fa-user-md</v-icon>
                    </template>
                      <span class="px-3 py-2"
                        style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                      ">{{ tiposEnvio[item.tipo_anexo].tipo }}</span>
                  </v-tooltip>
                <b>{{ item.nome.toUpperCase() }}</b>
              </v-col>
              <v-col class="px-2 py-1 text-left" cols="2">
                <b>Anexado a {{ item.qtde_anexada }} {{ item.qtde_anexada > 1?  tituloPorTipo[tipoConsulta][1]:  tituloPorTipo[tipoConsulta][0]}}</b>
              </v-col>
              <v-col class="px-2 py-1 text-left" cols="2">
                <b> {{item.formato_documento?formatoDocumentoTISS[item.formato_documento]:''}}</b>
              </v-col>
              <v-col class="px-2 py-1 text-left" cols="3">
                <b> {{item.tipo_documento?tipoDocumentoTISS[item.tipo_documento]:''}}</b>
              </v-col>
              <v-col class="px-2 py-0 text-right" cols="2">
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn icon x-small @click="download(item)" v-bind="attrs" v-on="on">
                      <v-icon x-small color="primary">fa fa-download</v-icon>
                    </v-btn>
                  </template>
                  <span class="px-3 py-2"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Download
                  </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn icon x-small @click="confirmarExclusao(item)" v-bind="attrs" v-on="on">
                      <v-icon x-small color="primary">fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <span class="px-3 py-2"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Excluir
                  </span>
                </v-tooltip>
              </v-col>
              <v-col class="pa-0 py-2" cols="12" v-if="ind < listaArquivos.length - 1">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <div class="text-center mt-4 py-0 col-md-12">
              <v-pagination
                class="no-box-shadow"
                v-model="page"
                :length="paginacao.total_pages"
                @input="getArquivosAnexo(null, page)"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="close()">
                FECHAR
              </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  components: {
    
  },
  data() {
    return {
      page: 1,
      tituloPorTipo: {
        lotes: ["lote", "lotes"],
        guias: ["guia", "guias"],
        itens: ["Item","itens"]
      },
      formatoDocumentoTISS: {
        null:"",
        "01":"JPG ou JPEG",
        "02":"PDF",
        "03":"PNG",
        "04":"TIFF",
        "05":"CADES - JPG ou JPEG",
        "06":"CADES PDF",
        "07":"CADES PNG",
        "08":"CADES TIFF",
        "09":"PADES"
      },
      tipoDocumentoTISS: {
        null:"",
        "01":"Comprovante de elegibilidade",
        "02":"Laudo do profissional de saúde",
        "03":"Pedido do profissional de saúde",
        "04":"Relatório do profissional de saúde",
        "05":"Prescrição do profissional de saúde",
        "06":"Comprovante de comparecimento (assinatura)",
        "07":"Embalagem/rótulo de materiais e/ou medicamentos",
        "08":"Comprovante de entrega de medicamentos",
        "09":"Notas fiscais",
        "10":"Boletim anestésico",
        "11":"Selos hemoterápicos",
        "12":"Exames de imagem",
        "13":"Exames de análises clínicas",
        "14":"Termo de consentimento",
        "15":"Guia de cobrança de taxa",
        "16":"Autorização prévia",
        "17":"Relatório de Auditoria"
      },
      tiposEnvio: [
        {id: null, tipo: 'Selecione'},
        {id: 1, tipo: 'Materiais - Medicamentos'},
        {id: 2, tipo: 'Procedimentos'}
      ],
      anexo_tiss: false
    }
  },
  watch: {
    dialog(val){
      if(val && this.parametros && this.parametros.RG_ANEXO_TISS) {
        this.anexo_tiss = this.parametros.RG_ANEXO_TISS
      }
    },
    listaArquivos() {
      this.page = this.paginacao?this.paginacao.offset:0;
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules
    }),
  },
  mounted() {
    if(this.parametros && this.parametros.RG_ANEXO_TISS) {
        this.anexo_tiss = this.parametros.RG_ANEXO_TISS
      }
      this.page = this.paginacao?this.paginacao.offset:0;
  }, 
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument"
    }),
    download(item){
      this.getDocument(item)
    },
    confirmarExclusao(item){
      let message = (this.obj_type=="guias")?
      'Não será possivel desfazer essa operação! Todas as guias, às quais este arquivo estava anexado, serão desvinculadas.':
      'Não será possivel desfazer essa operação! Todos os itens, aos quais este arquivo estava anexado, serão desvinculados.'
      
      let paramModal = {
        type: "warning",
        title: "EXCLUIR ARQUIVO!",
        message: message,
        callback: () => this.excluir(item),
        btConfirm: { name: "confirmar", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    excluir(item){
      let {data_pagamento, prestador_id, operadora_ans_id} =  this.dadosPagamento
      console.log('AnexosGestaoDlg', data_pagamento, prestador_id, operadora_ans_id)
      let payload = {grupo_economico: this.grupoEconomico, doc_id: item.doc_id, data_pagamento, prestador_id, operadora_ans_id}
      let obj = {query: [{Modulo: "Recebiveis", Acao: "DeleteAnexoRecursoUpload", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.getArquivosAnexo(null, 1)
      })
    }
  },
  props: {
    close: Function,
    dadosPagamento: Object,
    dialog: Boolean,
    getArquivosAnexo: Function,
    grupoEconomico: Number,
    listaArquivos: Array,
    parametros: Object,
    tipoConsulta: String,
    paginacao: Object
  },
};
</script>

<style>


</style>